// extracted by mini-css-extract-plugin
export default {"back-button":"vHunA","backButton":"vHunA","skeleton-placeholder-pulse":"m_My7","skeletonPlaceholderPulse":"m_My7"};